import { isLocalUrl } from '../localjs';

export default function () {
  const widgetName = 'seoWidget';
  const widgetOpts = seoWidgetOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: [''],
    itemsPerPanel: 1,
    maxItemsVisible: 1,
    showDescription: true,
    moreButton: false,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: false,
    buyNowButton: false,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (!hasData) {
        $(`#${widgetName}`).remove();
      } else {
        createCustomSeo(data.items);
      }
    },
  });

  function createCustomSeo(widgetData) {
    const { Title, Description, URL } = widgetData[0];
    const $seo = $(`#${widgetName}`).find('.card-widget-item');

    $seo.replaceWith(`
      <h1 class="seo-title">${Title}</h1>
      <div class="seo-description">${Description}</div>
      <a href="${URL}" class="button"  ${isLocalUrl(URL) ? '' : "target='_blank'"}>Get Tickets</a>
    `);
  }
}
